import React, { useEffect, useState } from 'react';
import { Button, Modal, Checkbox } from 'antd';
import styled from 'styled-components';
import { handleGetVocabPermission, handleUpdateVocabPermission } from 'store/organizations/thunks';
import Loading from 'components/Loading';
import { CheckCircle } from '@mui/icons-material';
import * as Sentry from '@sentry/react';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { useCurrentUser } from 'store/users/selectors';

const StyledButton = styled(Button)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const VocabAccessModal = ({ id, type }) => {
    const showAlert = useAlert();
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [vocabulary, setVocabulary] = useState(false);
    const [cognates, setCognates] = useState(false);
    const [en_sp_button, setEnSpButton] = useState(false);
    const [vocabLoader , setVocabLoader] = useState(false);
    const [hasPermisionConfig, setHasPermisionConfig] = useState(false);
    const currentUser = useCurrentUser()
    useEffect(() => {
        fetchData();
    }, [id]);

    const fetchData = async () => {
        try {
            setVocabLoader(true);
            const data = await handleGetVocabPermission(id);
            if (data && data.success && data.data) {
                const { vocab: vocabChecked, cognats: cognatesChecked, en_sp_button: enSpButtonChecked } = data.data || {};
                if(data&&data.data?.id){
                    setHasPermisionConfig(true);
                }
                setVocabulary(vocabChecked);
                setCognates(cognatesChecked);
                setEnSpButton(enSpButtonChecked);

            }else{
                if(!data || !data.success){
                    showAlert('Failed to fetch vocab access data', 'error');
                }
                setVocabulary(false);
                setCognates(false);
                setEnSpButton(false);
            }
        } catch (error) {
            console.log('error', error);
            showAlert('Something went wrong', 'error');
            Sentry.captureException(`273 Error fetching vocab permission: ${error}`);
        } finally{
            setVocabLoader(false);
        }
    };

    const handleUpdate = async () => {
        setLoading(true);
        try {
            const data = await handleUpdateVocabPermission({
                id,
                type,
                vocabulary,
                cognates,
                en_sp_button
            })
            if(data&&data.success){
                if(data&&data.data?.id){
                    setHasPermisionConfig(true);
                }
                showAlert('Updated successfully', 'success');
                setVisible(false);
            }else{
                showAlert('Update failed , please try again', 'error');
            }
        } catch (error) {
            Sentry.captureException(`274 Error updating vocab permission: ${error}`);
            showAlert('Update failed', 'error');
        } finally {
            setLoading(false);
        }
    };
     if(currentUser?.role!=="owe_admin") return null;
    return (
        <>
            <StyledButton
                type={"default"}
                onClick={() => setVisible(true)}
                icon={hasPermisionConfig && (vocabulary || cognates || en_sp_button)?<CheckCircle style={{ color: "green" , fontSize:16 }} />:null}
            >
                {vocabLoader ? <Loading  size={14} /> : null}    Block Access
            </StyledButton>
            <Modal
                open={visible}
                title={<div>
                    Block Access
                    <div style={{ fontSize: '12px', color: 'gray' }}>
                        This will block vocabulary, cognates, and EN-SP button access on student end.
                    </div>
                </div>}
                onOk={handleUpdate}
                confirmLoading={loading}
                onCancel={() => setVisible(false)}
                okText="Update"
            >
                <Checkbox
                    checked={vocabulary}
                    onChange={(e) => setVocabulary(e.target.checked)}
                >
                    Vocabulary
                </Checkbox>
                <br />
                <Checkbox
                    checked={cognates}
                    onChange={(e) => setCognates(e.target.checked)}
                >
                    Cognates
                </Checkbox>
                <br />
                <Checkbox
                    checked={en_sp_button}
                    onChange={(e) => setEnSpButton(e.target.checked)}
                >
                    EN-SP Button
                </Checkbox>
            </Modal>
        </>
    );
};

export default VocabAccessModal;
